export default __webpack_public_path__ + "static/media/0078.0300a81d.jpg";